/**
 * Created by Bart Decorte
 * Date: 14/09/2021
 * Time: 14:48
 */
import UploadPreviewSingle from './UploadPreviewSingle';

export default class UploadPreviewFile extends UploadPreviewSingle {
  renderFilename() {
    super.renderFilename();
  }

  clear() {
    super.clear();
    this.restore(this.storedFilename() ? this.storedFilename() : this.fallbackFilename());
  }

  restore(filename) {
    this.filenameEl().innerText = filename;
  }

  fallbackFilename() {
    return this.filenameEl().dataset.msgNoFile;
  }

  storedFilename() {
    return this.filenameEl().dataset.storedFilename;
  }

  hasStoredFilename() {
    return this.storedFilename() > '';
  }

  hasStoredData() {
    return this.hasStoredFilename();
  }

  filenameEl() {
    return this.rootEl.querySelector('.js-filename');
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/uploads/UploadPreviewFile.js